import { Component, OnInit } from '@angular/core';
import { CommerceService } from '../../../service/app/commerce.service';

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent implements OnInit {

  data;

  constructor(private commerceService: CommerceService) { }

  ngOnInit() {
    this.data = this.commerceService.wizard;
  }

  save(){
    this.commerceService.saveWizardData()
      .then(result=>{
        this.commerceService.savePage = true;
        //this.commerceService.disket.next(result);
        //this.commerceService.data = result;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/component/ui/action-button/action-button.component.ts